import apiService from '../api/apiService';
import { AxiosResponse } from 'axios';
import { ApiResponse } from '../types/notificationTypes';

const commonController = {
    getCountry: (): Promise<AxiosResponse<ApiResponse>> => apiService.get<ApiResponse>('/countries'),
    getState: (countryId : number): Promise<AxiosResponse<ApiResponse>> => apiService.get<ApiResponse>(`/states/${countryId}`),
    getCity: (stateId: number ): Promise<AxiosResponse<ApiResponse>> => apiService.get<ApiResponse>(`/cities/${stateId}`),
    getNotificationCount: (): Promise<AxiosResponse<ApiResponse>> => 
        apiService.get<ApiResponse>(`/notifications/unread-count`),
    getNotifications: (page: number = 0, size: number = 10): Promise<AxiosResponse<ApiResponse>> => 
        apiService.get<ApiResponse>(`/notifications?page=${page}&size=${size}`),
    readNotification: (notificationId: number): Promise<AxiosResponse<ApiResponse>> => 
        apiService.patch<ApiResponse>(`/notifications/read/${notificationId}`),
    
};

export default commonController;
